import script from "./upiPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./upiPayment.vue?vue&type=script&setup=true&lang=js"

import "./upiPayment.vue?vue&type=style&index=0&id=24da0502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24da0502"]])

export default __exports__